import gql from 'graphql-tag'
import { Insight } from 'graphql/types'

export type AdminInsightQueryType = {
  adminInsights: Insight[]
}

export default gql`
  query adminInsights($PartnerID: String) {
    adminInsights(PartnerID: $PartnerID) {
      UserEmail
      InsightID
      UserID
      GeneratedAt
      Domain
      Error
      Notes
      BillHash
      BillId
      Status
      Current
      Summary {
        ProviderName
        Source
      }
    }
  }
`
